import React from 'react';

const Home = () => {
  return <div>Welcome to Admin Dashboard</div>;
};

export default Home;